"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipBubble = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const tooltip_styles_1 = require("@/components/overlay/tooltip/tooltip.styles");
require("@/components/common");
const anchor_controller_1 = require("@/controllers/anchor-controller");
const portal_controller_1 = require("@/controllers/portal-controller");
/**
 * mm-tooltip이 트리거 곁에 띄우는 말풍선 표면.
 * mm-toast처럼 portal 컨테이너로 옮겨져, 트리거가 스크롤 영역이나 transform·contain을 가진 조상 안에 있어도 잘리지 않습니다.
 * 트리거의 자손이 아니므로 위치는 기준 요소(anchor)의 화면 좌표를 재어 정하고, 열려 있는 동안 스크롤·리사이즈를 따라갑니다.
 * 열림 상태와 내용은 트리거를 소유한 mm-tooltip이 채웁니다.
 */
let TooltipBubble = class TooltipBubble extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        /** @internal 말풍선을 소유한 mm-tooltip이 채운다. */
        this.content = '';
        /** @internal 말풍선을 소유한 mm-tooltip이 채운다. */
        this.placement = 'bottom-start';
        /** @internal 말풍선을 소유한 mm-tooltip이 채운다. */
        this.open = false;
        this.portal = new portal_controller_1.PortalController(this);
        this.anchorPosition = new anchor_controller_1.AnchorController(this, {
            getAnchor: () => this.anchor,
            isOpen: () => this.open,
            variables: {
                left: '--tooltip-bubble-anchor-left',
                right: '--tooltip-bubble-anchor-right',
                bottom: '--tooltip-bubble-anchor-bottom',
            },
        });
    }
    render() {
        return (0, lit_1.html) `
      <mm-text size="12">${this.content}</mm-text>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'tooltip');
    }
};
TooltipBubble.styles = tooltip_styles_1.tooltipBubbleStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TooltipBubble.prototype, "content", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], TooltipBubble.prototype, "placement", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], TooltipBubble.prototype, "open", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], TooltipBubble.prototype, "anchor", void 0);
TooltipBubble = __decorate([
    (0, decorators_js_1.customElement)('mm-tooltip-bubble')
], TooltipBubble);
exports.TooltipBubble = TooltipBubble;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9vbHRpcC1idWJibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0b29sdGlwLWJ1YmJsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBc0M7QUFDdEMscURBQTJEO0FBSTNELGdGQUFpRjtBQUNqRiwrQkFBNEI7QUFDNUIsdUVBQWtFO0FBQ2xFLHVFQUFrRTtBQUVsRTs7Ozs7R0FLRztBQUVJLElBQU0sYUFBYSxHQUFuQixNQUFNLGFBQWMsU0FBUSxnQkFBVTtJQUF0Qzs7UUFFTCwwQ0FBMEM7UUFDZCxZQUFPLEdBQUcsRUFBRSxDQUFBO1FBQ3hDLDBDQUEwQztRQUNDLGNBQVMsR0FBcUIsY0FBYyxDQUFBO1FBQ3ZGLDBDQUEwQztRQUNFLFNBQUksR0FBRyxLQUFLLENBQUE7UUFHaEQsV0FBTSxHQUFHLElBQUksb0NBQWdCLENBQUMsSUFBSSxDQUFDLENBQUE7UUFDbkMsbUJBQWMsR0FBRyxJQUFJLG9DQUFnQixDQUFDLElBQUksRUFBRTtZQUNsRCxTQUFTLEVBQUUsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLE1BQU07WUFDNUIsTUFBTSxFQUFFLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJO1lBQ3ZCLFNBQVMsRUFBRTtnQkFDVCxJQUFJLEVBQUUsOEJBQThCO2dCQUNwQyxLQUFLLEVBQUUsK0JBQStCO2dCQUN0QyxNQUFNLEVBQUUsZ0NBQWdDO2FBQ3pDO1NBQ0YsQ0FBQyxDQUFBO0lBWUosQ0FBQztJQVZDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzJCQUNZLElBQUksQ0FBQyxPQUFPO0tBQ2xDLENBQUE7SUFDSCxDQUFDO0lBRUQsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLENBQUE7SUFDdEMsQ0FBQzs7QUE3Qk0sb0JBQU0sR0FBRyxvQ0FBbUIsQ0FBQTtBQUVQO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs4Q0FBYTtBQUVHO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO2dEQUE2QztBQUUzQztJQUEzQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzsyQ0FBYTtBQUV4QjtJQUEvQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLENBQUM7NkNBQXFCO0FBVHpDLGFBQWE7SUFEekIsSUFBQSw2QkFBYSxFQUFDLG1CQUFtQixDQUFDO0dBQ3RCLGFBQWEsQ0ErQnpCO0FBL0JZLHNDQUFhIn0=